import { createFileRoute } from '@tanstack/react-router';
import { Authn, HandleCallbackProps } from '@frontend/auth';
import { AuthStorage, localStorageHelper, SsoTenant } from '@frontend/auth-helpers';
import { SignInCallback } from '../../components';

export const Route = createFileRoute('/sso/callback')({
  component: SsoCallbackRouteComponent,
});

function SsoCallbackRouteComponent() {
  const auth: Authn = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const navigate = Route.useNavigate();
  const getAuthCallbackProps = (): HandleCallbackProps | undefined => {
    const ssoTenant = localStorageHelper.get<SsoTenant>(AuthStorage.sso_tenant);
    if (!!ssoTenant) {
      return {
        clientId: ssoTenant.clientId,
        redirectUri: new URL(ssoTenant.redirectUri),
      };
    }
    return undefined;
  };

  return <SignInCallback<`/sso/callback`> {...{ auth, navigate, getAuthCallbackProps, signInMethod: 'oidc' }} />;
}
